import { FInput, FLabel } from "../../pages/engagement/FormControls";
import { PharmacyPicker } from "./PharmacyPicker";

const FLAGS = [["daw", "Dispense as written"], ["prn", "As needed (PRN)"], ["label", "Label"], ["med_ed", "Med/Ed discussed"], ["samples", "Sample(s) dispensed"]];

/** Max daily dose, per-medication pharmacy, and the Label, Med/Ed, DAW, PRN, and samples flags for one Rx line. */
export function RxLineExtras({ t, line, onChange, pharmacies, onPharmacyAdded, defaultPharmacy }) {
  return (
    <>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-3">
        <div><FLabel>Max daily dose</FLabel><FInput data-testid={`${t}-max-dose`} value={line.max_daily_dose || ""} onChange={(e) => onChange({ max_daily_dose: e.target.value })} placeholder="e.g., 450 mg" /></div>
        <div className="col-span-2"><FLabel>Pharmacy for this medication</FLabel>
          <PharmacyPicker testId={`${t}-pharmacy`} pharmacies={pharmacies} value={line.pharmacy_id || ""} fallback={defaultPharmacy}
            placeholder={defaultPharmacy ? `Same as prescription (${defaultPharmacy.name})` : "Same as prescription pharmacy"}
            onPick={(id) => onChange({ pharmacy_id: id })} onAdd={onPharmacyAdded} showContact /></div>
      </div>
      <div className="flex flex-wrap gap-x-5 gap-y-2 text-xs text-[#5D4037]">
        {FLAGS.map(([k, label]) => (
          <label key={k} className="flex items-center gap-2"><input type="checkbox" data-testid={`${t}-${k.replace("_", "-")}`} checked={!!line[k]}
            onChange={(e) => onChange({ [k]: e.target.checked, ...(k === "samples" && !e.target.checked ? { samples_amount: "" } : {}) })} className="h-4 w-4 accent-[#4E342E]" /> {label}</label>
        ))}
      </div>
      {line.samples && <div className="max-w-xs"><FLabel>Samples amount *</FLabel><FInput data-testid={`${t}-samples-amount`} value={line.samples_amount || ""} onChange={(e) => onChange({ samples_amount: e.target.value })} placeholder="e.g., 14 tablets, lot 4471A" /></div>}
    </>
  );
}
